export enum EnumTipoUsoGas {
  GAS_USO_1_09 = 1,
  GAS_USO_1_10_1_COGENERACION,
  GAS_USO_1_10_2_COGENERACION,
  GAS_USO_1_10_1_NO_CARBURANTES,
  GAS_USO_1_10_2_PROFESIONAL,
  GAS_USO_1_10_1_CICLO_COMBINADO = 10,
  GAS_USO_1_10_1_CENTRAL_TERMICA
}
